import { atom } from 'jotai';

export interface SearchSessionState {
  active: boolean;
  timerStartedAt: number | null;
  accumulatedActiveMs: number;
  searchCount: number;
  resourceClicks: number;
  /** Queries paired with search submits until flushed into `useSearchSession`. */
  pendingSearchQueries: string[];
}

const DEFAULT_STATE: SearchSessionState = {
  active: false,
  timerStartedAt: null,
  accumulatedActiveMs: 0,
  searchCount: 0,
  resourceClicks: 0,
  pendingSearchQueries: [],
};

export const searchSessionAtom = atom(DEFAULT_STATE);
searchSessionAtom.debugLabel = 'searchSession';

export const incrementSearchCountAtom = atom(
  null,
  (get, set, query?: string) => {
    const prev = get(searchSessionAtom);
    set(searchSessionAtom, {
      ...prev,
      searchCount: prev.searchCount + 1,
      pendingSearchQueries:
        query !== undefined
          ? [...prev.pendingSearchQueries, query]
          : prev.pendingSearchQueries,
    });
  },
);

incrementSearchCountAtom.debugLabel = 'incrementSearchCount';

export const incrementResourceClicksAtom = atom(null, (get, set) => {
  const prev = get(searchSessionAtom);
  set(searchSessionAtom, {
    ...prev,
    resourceClicks: prev.resourceClicks + 1,
  });
});

incrementResourceClicksAtom.debugLabel = 'incrementResourceClicks';

export const resetSearchSessionAtom = atom(null, (_get, set) => {
  set(searchSessionAtom, DEFAULT_STATE);
});
resetSearchSessionAtom.debugLabel = 'resetSearchSession';
